var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.27,
    height: 126.799,
    viewBox: "0 0 144.27 126.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attention",
    transform: "translate(0 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M15.768,157.8a15.75,15.75,0,0,1-6.34-1.31,15.519,15.519,0,0,1-5-3.486,15.886,15.886,0,0,1-3.257-5,15.44,15.44,0,0,1,1.22-14.145L58.711,38.447l.039-.065A15.7,15.7,0,0,1,72.092,31h.085a15.7,15.7,0,0,1,13.342,7.383l.039.065,35.915,60.841v0a2.818,2.818,0,0,1-2.423,4.249,2.833,2.833,0,0,1-2.429-1.386L80.735,41.361a10.189,10.189,0,0,0-17.188-.02L7.222,136.756l-.039.065a9.849,9.849,0,0,0-1.547,5.272,10.178,10.178,0,0,0,2.852,7,9.975,9.975,0,0,0,7.306,3.069H128.476a9.969,9.969,0,0,0,7.3-3.069,10.168,10.168,0,0,0,2.854-7,9.835,9.835,0,0,0-1.55-5.272l-.037-.065-7.535-12.764a2.818,2.818,0,0,1,2.423-4.249,2.83,2.83,0,0,1,2.429,1.384l7.521,12.742A15.435,15.435,0,0,1,143.1,148a15.845,15.845,0,0,1-3.26,5,15.477,15.477,0,0,1-5,3.486,15.8,15.8,0,0,1-6.34,1.31Z",
    transform: "translate(0)",
    fill: "#15113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M163.71,179.622H53.818a2.818,2.818,0,0,1-2.426-4.251l54.946-92.986a2.818,2.818,0,0,1,4.852,0l54.946,92.986a2.818,2.818,0,0,1-2.426,4.251ZM58.755,173.986H158.772l-50.008-84.63Z",
    transform: "translate(-36.629 -35.911)",
    fill: "#15113d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M234.453,346.907a8.453,8.453,0,1,1,8.453-8.453A8.463,8.463,0,0,1,234.453,346.907Zm0-11.271a2.818,2.818,0,1,0,2.818,2.818A2.821,2.821,0,0,0,234.453,335.636Z",
    transform: "translate(-162.319 -214.749)",
    fill: "#e02020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M234.453,221.658c-3.088,0-4.327-3.583-4.857-5.113a56.222,56.222,0,0,1-1.9-7.713,103.116,103.116,0,0,1-1.7-13.378,8.453,8.453,0,0,1,16.907,0,103.118,103.118,0,0,1-1.7,13.378,56.222,56.222,0,0,1-1.9,7.713C238.781,218.075,237.542,221.658,234.453,221.658Zm0-29.023a2.821,2.821,0,0,0-2.818,2.818,96.572,96.572,0,0,0,1.329,10.814,69.632,69.632,0,0,0,1.489,6.927,69.737,69.737,0,0,0,1.489-6.927,96.571,96.571,0,0,0,1.329-10.814A2.821,2.821,0,0,0,234.453,192.636Z",
    transform: "translate(-162.319 -112.043)",
    fill: "#e02020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 2.818,
    cy: 2.818,
    r: 2.818,
    transform: "translate(122.673 108.824)",
    fill: "#15113d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.ba82387bbf7e5e692dab48675ed459fa.svg";
export { ForwardRef as ReactComponent };